import {
    FirestoreUser,
    FirestoreUserRole,
    FirestoreUserStatus,
} from 'generated/graphql';
import { UserData } from 'Interfaces/User/UserData';
import convertToQualityOnboarding from './convertToQualityOnboarding';

export function firestoreToUserData(user: FirestoreUser): UserData {
    return {
        id: user.id,
        email: user.email,
        secondaryEmail: user.email,
        hasTakenTour: user.hasTakenTour,
        instanceId: user.organizationId,
        isGlobalAdmin: user.roles.includes(FirestoreUserRole.OrganizationAdmin),
        joinedDate: user.createdAt,
        lastChangelog: user.updatedAt,
        notificationSettings: user.notificationSettings,
        name: user.displayName || `${user.firstName} ${user.lastName}`,
        photoURL: user.photoURL,
        objectType: 'firestore-user',
        status: user.status,
        teamId: user.teamId,
        uid: user.uid,
        qualityOnboarding: convertToQualityOnboarding(user.waizenOnboarding),
        roles: user.roles,
    };
}

export default firestoreToUserData;
